import React from 'react';

const FlipCardSvg = () => {
  return (
    <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <g fill="#a3a3a2" fillRule="evenodd">
          <path d="M11 2.3V2c0-.56-.45-1-1-1H4c-.55 0-1 .45-1 1v1.43c-.9.34-1.5.78-1.5 1.27 0 .65 1.05 1.23 2.5 1.57V8.2c-.35-.1-.68-.18-1-.28V11c0 .56.45 1 1 1h6c.55 0 1-.45 1-1V7.92c-.32.1-.65.2-1 .27V6.25c1.45-.34 2.5-.92 2.5-1.57 0-.5-.6-.94-1.5-1.28V2.3zm1 .7V2c0-1.1-.9-2-2-2H4C2.9 0 2 .9 2 2v1c-1.24.6-2 1.38-2 2.27 0 .88.76 1.68 2 2.26V11c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V7.53c1.24-.58 2-1.38 2-2.26 0-.9-.76-1.68-2-2.27zM2 3zm1 4.92V10H2V7.53c.3.14.64.27 1 .4zM12 3zm0 4.53V10h-1V7.92c.36-.12.7-.25 1-.4zM4 5.5c0-.82.55-1.1 1.23-.63L7.55 6.5c.68.46.68 1.23 0 1.7L5.23 9.84c-.68.47-1.23.2-1.23-.64V5.5z" />
        </g>
      </g>
    </svg>
  );
};

export default FlipCardSvg;
